import { jsx } from 'react/jsx-runtime';
import { Document as Document$1 } from 'react-pdf';
import { usePDFContent } from './PDF.js';
import RowPageList from './RowPageList.js';
import { styled } from 'styled-components';
import { Spinner } from '@fabric-app/ui/components/Spinner';

const options = {
  cMapUrl: "/pdf/cmaps/",
  cMapPacked: true,
  standardFontDataUrl: "/pdf/standard_fonts/"
};
const Document = styled(Document$1).withConfig({
  displayName: "PDFDocument__Document",
  componentId: "sc-38f01083-0"
})([
  `flex-grow:1;display:flex;flex-direction:column;align-items:center;.textLayer{::selection{background:blue;}br{visibility:hidden;}}.annotationLayer{user-select:none;*{user-select:none;}}[data-selecting='true']{.annotationLayer{pointer-events:none;display:none;}.textLayer{span{user-select:text !important;z-index:2;&::before{content:'';z-index:-1;position:absolute;user-select:none;}&[data-current='true']{z-index:1;&::before{top:-50px;left:-50px;bottom:-50px;right:-50px;}}}br{user-select:none;::selection{background:transparent;}}}}`
]);
const PdfDocument = ({ wrapperRef, isFullScreen, tinyPagesIsVisible, width, hasSelection, isMouseDown, fileUrl, onLoadSuccess, onLoadError }) => {
  const { scrollToPage } = usePDFContent();
  return /* @__PURE__ */ jsx(Document, {
    onItemClick: (data) => {
      scrollToPage?.(data.pageNumber);
    },
    options,
    file: fileUrl,
    onLoadSuccess,
    onLoadError,
    renderMode: "canvas",
    "data-selecting": hasSelection && isMouseDown,
    loading: /* @__PURE__ */ jsx("div", {
      style: {
        marginTop: 80,
        width,
        display: "flex",
        justifyContent: "center"
      },
      children: /* @__PURE__ */ jsx(Spinner, {
        size: 30,
        thickness: 3
      })
    }),
    children: wrapperRef && /* @__PURE__ */ jsx(RowPageList, {
      root: wrapperRef,
      width: isFullScreen && tinyPagesIsVisible ? width - 114 : width
    })
  });
};

export { PdfDocument };
//# sourceMappingURL=PDFDocument.js.map
